module.exports = __webpack_public_path__ + "img/wz-5-4.30a5200f.png";